/**
 * It takes a size and returns a hash table object with methods to add, delete, and lookup items in the
 * hash table
 * @param size - The size of the hash table.
 */
const hashTable = function (size) {

    let storage = []

    /* A function that returns the storage array and the length of the storage array. */
    this.printStorage = () => {
        return { storage: storage, length: storage.length }
    }

    this.getStorage = () => {
        return storage
    }

    /* A hash function that takes a string and a max value and returns a hash value. */
    this.hash = (str, max) => {
        let hash = 0
        for (let i = 0; i < str.length; i++) {
            hash += str.charCodeAt(i)
        }
        return hash % max
    }

    /* Adding an item to the hash table. */
    this.addItem = (item) => {
        const storageIndex = this.hash(item[0], size)
        if (!storage[storageIndex]) {
            storage[storageIndex] = [item]
        } else {
            storage[storageIndex].push(item)
        }
    }

    /* Deleting an item from the hash table. */
    this.deleteItem = (item) => {
        const storageIndex = this.hash(item[0], size)
        const node = storage[storageIndex] || []
        for (let i = 0; i < node.length; i++) {
            if (node[i][0] === item) {
                node.splice(i, 1)
                return
            }
        }
    }

    /* Looking up the item in the hash table. */
    this.lookupItem = (item) => {
        const storageIndex = this.hash(item[0], size)
        const node = storage[storageIndex] || []
        for (let i = 0; i < node.length; i++) {
            if (node[i][0] === item[0]) {
                //console.log(`runtime complexity O(${i + 1})`)
                return node[i]
            }
        }
        return null
    }

    /* Looking up the item in the hash table. */
    this.findDuplicates = (item) => {
        const storageIndex = this.hash(item[0], size)
        const node = storage[storageIndex] || []
        let items = []
        for (let i = 0; i < node.length; i++) {
            if (node[i][0] === item) {
                items.push({ item: node[i], storageIndex: storageIndex, nodeIndex: i })
            }
        }
        return items
    }

    this.updateItem = (item) => {
        const storageIndex = this.hash(item[0], size)
        let node = storage[storageIndex] || []
        for (let i = 0; i < node.length; i++) {
            if (node[i][0] === item[0]) {
                node[i] = item
                storage[storageIndex] = node
            }
        }
    }

    /* Clearing the storage array. */
    this.purgeTable = (print) => {
        storage = []
        if (print) {
            this.printStorage()
        }
    }
}

export default hashTable